export function LocalStorageGet<T>(key: string): T | null {
    if (window.localStorage) {
        const value = window.localStorage.getItem(key);
        try {
            return value ? JSON.parse(value) as T : null
        } catch (err) {
            LocalStorageRemove(key);
            return null;
        }
    }
    return null
}

export function LocalStorageSet<T>(key: string, value: T) {
    if (window.localStorage) {
        window.localStorage.setItem(key, JSON.stringify(value));
    }
}

export function LocalStorageRemove(key: string) {
    if (window.localStorage) {
        window.localStorage.removeItem(key);
    }
}

export function LocalStorageClear() {
    if (window.localStorage) {
        window.localStorage.clear();
    }
}

export function SortByKey<T>(data: T[], key: keyof T) {
    return data.sort((e1, e2) => {
        const v1 = ((e1[key] || '') as string).trim().toLocaleLowerCase();
        const v2 = ((e2[key] || '') as string).trim().toLocaleLowerCase();
        return v1.localeCompare(v2);
    })
}